import script from "./CommercialDisclosureComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CommercialDisclosureComponent.vue?vue&type=script&setup=true&lang=js"

import "./CommercialDisclosureComponent.vue?vue&type=style&index=0&id=3d54f38d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d54f38d"]])

export default __exports__